"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _reactRedux = require("react-redux");

var _reactBootstrap = require("react-bootstrap");

var _QuestionsActions = require("../../redux/Questions/QuestionsActions");

require("../../../css/DropdownProperties.css");

require("../../../css/CommonProperties.css");

var _config = require("../../config/config");

var _DropdownOption = _interopRequireDefault(require("./Fields/DropdownOption"));

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable no-underscore-dangle */


var DropdownProperties = function DropdownProperties(_ref) {
  var question = _ref.question,
      updateDropdownQuestion = _ref.updateDropdownQuestion,
      errorMessages = _ref.errorMessages; // future refactor: make the test server remove _destroyed answers the way the real thing does so we can remove this filter

  var validAnswers = function validAnswers(answerAttributes) {
    return answerAttributes.filter(function (answer) {
      return answer._destroy !== true;
    }) || [];
  };

  var _useState = (0, _react.useState)(validAnswers(question.answers_attributes)),
      answers = _useState[0],
      setAnswers = _useState[1];

  (0, _react.useEffect)(function () {
    setAnswers(validAnswers(question.answers_attributes) || []);
  }, [question.answers_attributes]);

  var onEditAnswer = function onEditAnswer(e) {
    var answerId = parseInt(e.target.getAttribute('answerid'), 10);
    var updatedAnswers = answers.map(function (answer) {
      if (answer.id === answerId) {
        return (0, _extends2["default"])({}, answer, {
          name: e.target.value,
          _destroy: false
        });
      }

      return answer;
    });
    setAnswers(updatedAnswers);
  };

  var onAnswerBlur = function onAnswerBlur() {
    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: answers
    });
    updateDropdownQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var onRemoveAnswer = function onRemoveAnswer(answerId) {
    // Prevent removing minimum number of answers
    if (answers.length <= 2) {
      return;
    }

    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: answers.map(function (answer) {
        if (answer.id === answerId) {
          return (0, _extends2["default"])({}, answer, {
            _destroy: true
          });
        }

        return answer;
      })
    });
    updateDropdownQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var onAddAnswer = function onAddAnswer() {
    var newAnswer = {
      name: '__answer_name__',
      position: answers.length + 1,
      _destroy: false
    };
    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: [].concat(answers, [newAnswer])
    });
    updateDropdownQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("h6", {
      className: "font-weight-bold mt-2"
    }, "Dropdown Options"), answers.map(function (answer) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_DropdownOption["default"], {
          key: answer.id,
          answer: answer,
          handleAnswerBlur: onAnswerBlur,
          handleEditAnswer: onEditAnswer,
          enableRemove: answers.length > 2,
          handleRemoveAnswer: onRemoveAnswer,
          errorMessages: errorMessages
        })
      );
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "text-center"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      id: "btnAddAnswer",
      variant: "outline-primary",
      className: "w-50 my-2",
      "data-cy": "dropdown-add-button",
      onClick: onAddAnswer
    }, ' ', "+ Add Option"))))
  );
};

DropdownProperties.defaultProps = {
  errorMessages: false
};
DropdownProperties.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  question: _propTypes["default"].objectOf(_propTypes["default"].any).isRequired,
  updateDropdownQuestion: _propTypes["default"].func.isRequired,
  errorMessages: _propTypes["default"].bool
} : {};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateDropdownQuestion: function updateDropdownQuestion(question, lastSave) {
      return dispatch((0, _QuestionsActions.waitApiUpdateQuestion)(question, lastSave));
    }
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(DropdownProperties);